import {tns} from 'tiny-slider/src/tiny-slider.module';

export const initRecentlyViewedSlider = () => {
  for (const slider of document.getElementsByClassName('recently-viewed-slider__inner')) {
    const sliderContainer = slider.getElementsByClassName('recently-viewed-slider__slide-container')[0];
    const tinyslider = tns({
      container: sliderContainer,
      items: 1,
      controls: true,
      mouseDrag: true,
      nav: false,
      lazyload: true,
      gutter: 20,
      responsive: {
        760: {
          edgePadding: 15,
          items: 2,
        },
        960: {
          items: 3,
        },
        1300: {
          gutter: 30,
          items: 4
        },
        1440: {
          gutter: 30,
          items: 5
        }
      },
      controlsContainer: slider.getElementsByClassName('recently-viewed-slider__controls')[0]
    });
    slider.style.height = 'auto';
  }
};
